// extracted by css-extract-rspack-plugin
export default {"chevronIcon":"LVUqw","opened":"p9lXe"};